import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { withPlugins, domEvents } from '@spon/plugins';
import toggle from '@/ui/toggle';

gsap.registerPlugin(SplitText);

function Header({ node, name, plugins: { addEvents } }) {
	if (!node) return;

	let activeNav = null;

	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop) window.scroll(0, windowTop);
		},
	};

	const nav = toggle({
		button: node.querySelector('.burger'),
		name,
		activeClass: 'is-active',
	});

	/*
	 *		Nav animation
	 */

	const primaryNav = node.querySelector('#primary-navigation');
	const navLinks = primaryNav
		? [...primaryNav.querySelectorAll('.nav__link')]
		: [];

	// Moved to CSS for more instant application, for first page load..
	// gsap.set(primaryNav, { clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)' });

	let split = null;

	const navTl = gsap.timeline({
		paused: true,
	});

	document.fonts.ready.then(() => {
		split = navLinks.length
			? new SplitText(navLinks, {
					type: 'lines',
					mask: 'lines',
				})
			: null;

		navTl.to(primaryNav, {
			clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
			duration: 0.5,
			ease: 'cubic-bezier(0.71, 0.01, 0.27, 0.99)',
		});

		if (split) {
			navTl.from(
				split.lines,
				{
					yPercent: 100,
					duration: 0.6,
					stagger: 0.08,
					ease: 'cubic-bezier(0.71, 0.01, 0.27, 0.99)',
				},
				'-=0.2'
			);
		}
	});

	function onNavClick(event) {
		event.preventDefault();

		if (activeNav) activeNav.classList.remove('is-active');

		const { target: link } = event;
		const href = link.getAttribute('href');

		const targetEl = document.querySelector(href);

		activeNav = link;
		if (activeNav) activeNav.classList.add('is-active');

		if (targetEl) {
			windowTop = targetEl.getBoundingClientRect().top + windowTop;
			lock.release();

			// window.history.pushState(null, '', href.replace(/\/$/, ''));
		}
		nav.close();
	}

	/*
	 *		Functions
	 */

	function clickWhenOpenHandle({ target }) {
		if (target.id === 'header' || target.closest('#header')) return; // Continue if clicking within #Header
		nav.close();
	}

	nav.on(`open:${name}`, ({ target }) => {
		node.classList.add('nav-open');
		target.classList.add('is-open');
		lock.capture();
		document.addEventListener('click', clickWhenOpenHandle);
		navTl.play();
	});

	nav.on(`close:${name}`, ({ target }) => {
		navTl.eventCallback('onReverseComplete', () => {
			node.classList.remove('nav-open');
			target.classList.remove('is-open');
			lock.release();
			document.removeEventListener('click', clickWhenOpenHandle);
		});
		navTl.reverse();
	});

	// Main Mobile Menu END

	function onKeyDown(event) {
		const { key } = event;
		if (key === 'Escape') {
			if (nav.isOpen) {
				nav.close();
			}
		}
	}

	/*
	 *		Hero observer — shrink burger once hero scrolls out of view
	 */
	let heroObserver = null;
	const hero = document.querySelector('.landing-hero-block');
	if (hero) {
		heroObserver = new IntersectionObserver(
			([entry]) => {
				node.classList.toggle('is-hero-past', !entry.isIntersecting);
			},
			{ threshold: 0 }
		);
		heroObserver.observe(hero);
	}

	/*
	 *		Init
	 */
	nav.init();

	/*
	 *		Events
	 */

	addEvents({
		'click .nav__link': onNavClick,
	});

	addEvents(document.body, {
		click: ({ target }) => {
			if (target.id === 'header' || target.closest('#header')) return;
		},
		keydown: onKeyDown,
	});

	return () => {
		if (heroObserver) heroObserver.disconnect();
	};
}

export default withPlugins(domEvents)(Header);
